.tree {
  min-width: 0;
  padding: 6px;
  font-family: var(--font-mono);
  font-size: 13px;
  user-select: none;
}

.row {
  display: flex;
  width: 100%;
  min-width: 0;
  height: 30px;
  align-items: center;
  gap: 6px;
  padding: 0 6px 0 4px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  white-space: nowrap;
}

button.row {
  cursor: pointer;
}

.row:focus-visible {
  outline: 2px solid var(--outline);
  outline-offset: -2px;
  background: var(--surface-2);
}

.disclosure {
  display: inline-grid;
  width: 14px;
  height: 14px;
  flex: none;
  place-items: center;
  color: var(--on-surface-secondary);
}

.chevron {
  transition: transform 100ms cubic-bezier(0.22, 1, 0.36, 1);
}

.open {
  transform: rotate(90deg);
}

.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}

.name {
  min-width: 0;
  overflow: hidden;
  font-weight: 500;
  text-overflow: ellipsis;
}

.log {
  overflow: hidden;
  text-overflow: ellipsis;
}

.level {
  flex: none;
  font-size: 11px;
  text-transform: uppercase;
}

/* Waterfall: one fixed-width lane per row, right-aligned so lanes line up at every depth. */
.timing {
  display: flex;
  flex: none;
  align-items: center;
  margin-left: auto;
}

.lane {
  width: 16rem;
  height: 8px;
  border-radius: 4px;
  background: var(--surface-2);
}

.bar {
  display: block;
  min-width: 2px;
  height: 100%;
  border-radius: 4px;
}

.ruler {
  justify-content: space-between;
  width: 16rem;
  margin-left: auto;
  padding: 0 6px 4px 0;
  color: var(--on-surface-secondary);
  font-size: 11px;
}

.children {
  position: relative;
  margin-left: 16px;
}

.children::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -5px;
  width: 1px;
  background: var(--border);
}

/* Embed Arc's node layout while retaining the diagnostic viewer's type colors. */
.valueTree {
  border: 0;
  border-radius: 0;
  background: transparent;
}

.valueTree [role='tree'] {
  padding: 0;
  overflow: visible;
  overscroll-behavior: auto;
}

/* The trace owns navigation; embedded payloads only need their node rows. */
.valueTree > div:not([role='tree']) {
  display: none;
}

.valueTree:not(:focus-within) [role='treeitem'] > span[aria-hidden='true'] {
  display: none;
}

.valueTree [data-type='string'] {
  color: var(--color-green-600);
}

.valueTree [data-type='number'] {
  color: var(--color-blue-600);
}

.valueTree [data-type='boolean'] {
  color: var(--color-purple-600);
}

.valueTree [data-type='null'],
.valueTree [data-type='other'] {
  color: var(--color-red-600);
  font-style: italic;
}

:global(.dark) .valueTree [data-type='string'] {
  color: var(--color-green-400);
}

:global(.dark) .valueTree [data-type='number'] {
  color: var(--color-blue-400);
}

:global(.dark) .valueTree [data-type='boolean'] {
  color: var(--color-purple-400);
}

:global(.dark) .valueTree [data-type='null'],
:global(.dark) .valueTree [data-type='other'] {
  color: var(--color-red-400);
}

@media (hover: hover) and (pointer: fine) {
  button.row:hover {
    background: var(--surface-2);
  }
}

@media (prefers-reduced-motion: reduce) {
  .chevron {
    transition: none;
  }
}
